module.exports = __webpack_public_path__ + "static/img/ftux-design.856175e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ftux-design.png
// module id = PLYm
// module chunks = 0